<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <label>Please add a comment:</label>
  <textarea
    [ngModel]="comment"
    (ngModelChange)="onCommentChange($event)"
    class="form-control"
    rows="4"
    [attr.maxlength]="maxCommentLength > 0 ? maxCommentLength : null"
    placeholder="Enter your comment..."
  ></textarea>
  @if (showCharCount && maxCommentLength > 0) {
<div class="comments-modal-counter">
    {{ (comment || '').length }} / {{ maxCommentLength }}
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saveDisabled" (click)="save()">Save</button>
</div>
